import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { memo } from "react";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { Amount } from "@design-system/Amount/Amount";
import { MatchableItem } from "../types";

export const AmountCell = memo(
    ({ row }: CellContext<ViewTableFeatures, MatchableItem, unknown>) => (
        <ViewTableCell>
            <Amount amount={row.original.amount} showNegative />
        </ViewTableCell>
    ),
);
AmountCell.displayName = "AmountCell";
